import { createApp } from 'vue'; // Import createApp instead of Vue
import FlyoverPreview from './FlyoverPreview.vue';
import store from './store/store';

// Find the target element first
const targetElement = document.querySelector('#flyover_preview');

// Check if the element exists before trying to mount
if (targetElement) {
  const app = createApp(FlyoverPreview);
  app.use(store);
  app.mount(targetElement);
}
